import React, { createContext, useContext } from 'react';

/**
 * Dashboard Context
 * Provides mode-specific configuration for the unified dashboard
 */

export const DASHBOARD_MODES = {
  KID: 'kid',
  GUARDIAN: 'guardian'
};

const DashboardContext = createContext(null);

export const useDashboardContext = () => {
  const context = useContext(DashboardContext);
  if (!context) {
    throw new Error('useDashboardContext must be used within a DashboardProvider');
  }
  return context;
};

export const DashboardProvider = ({ mode, children, data = null }) => {
  const isKid = mode === DASHBOARD_MODES.KID;
  const isGuardian = mode === DASHBOARD_MODES.GUARDIAN;

  const config = {
    mode,
    isKid,
    isGuardian,
    // API base URL
    apiBaseUrl: isKid ? '/api/children' : '/api',
    // Router base path
    basePath: isKid ? '/children' : '/guardian',
    // Sign out endpoint
    signOutAction: isKid ? '/children/session' : '/logout',
    // Translation namespace
    translationPrefix: isKid ? 'children' : 'guardian',
    // User data (kid profile or null for guardian)
    userData: data
  };

  return (
    <DashboardContext.Provider value={config}>
      {children}
    </DashboardContext.Provider>
  );
};

export default DashboardContext;
